export function checkValue(value: string | null): boolean {
    return !!value;
}
